import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import * as stylex from "@stylexjs/stylex";
import { queries, errorMessage } from "../lib/api";
import { styles } from "../lib/styles";
export const Route = createFileRoute("/connect")({ component: ConnectPage });
function ConnectPage() {
  const aliases = useQuery(queries.aliases());
  return (
    <>
      <div {...stylex.props(styles.pageHeading)}>
        <div>
          <h1 {...stylex.props(styles.title)}>Connect from your device</h1>
          <p {...stylex.props(styles.description)}>
            Sign in once, then use ordinary SSH from your terminal, editor, or AI agent. Your key is
            generated locally and never uploaded.
          </p>
        </div>
      </div>
      <div {...stylex.props(styles.grid)}>
        <section {...stylex.props(styles.panel)}>
          <h2 {...stylex.props(styles.panelHeading)}>Set up SSH</h2>
          <p {...stylex.props(styles.description)}>
            <a href="/install.ps1" download>
              Windows installer
            </a>{" "}
            or{" "}
            <a href="/install.sh" download>
              Linux / macOS installer
            </a>
            . <a href="/downloads/checksums.json">SHA256 checksums</a>
          </p>
          <p {...stylex.props(styles.description)}>
            Install your administrator-provided ssbi-ssh executable, connect NetBird, and run:
          </p>
          <pre {...stylex.props(styles.code)}>
            ssbi-ssh login --url {window.location.origin}
            {`\n`}ssbi-ssh status{`\n`}ssbi-ssh doctor
          </pre>
          <p {...stylex.props(styles.small)}>
            Login opens company SSO and issues a certificate valid for up to eight hours. Alias
            updates are available with ssbi-ssh sync. If a personal alias conflicts, the CLI
            preserves it and explains how to resolve the conflict.
          </p>
        </section>
        <section {...stylex.props(styles.panel)}>
          <h2 {...stylex.props(styles.panelHeading)}>Your available aliases</h2>
          {aliases.error && (
            <p role="alert" {...stylex.props(styles.error)}>
              {errorMessage(aliases.error)}
            </p>
          )}
          {aliases.data?.map((a) => (
            <div key={a.alias}>
              <pre {...stylex.props(styles.code)}>ssh {a.alias}</pre>
              <p {...stylex.props(styles.small)}>
                {a.login}@{a.address}:{a.port}
              </p>
            </div>
          ))}
          {aliases.data?.length === 0 && (
            <p {...stylex.props(styles.empty)}>
              No applied access grants. Ask your administrator to check your NetBird SSH group and
              synchronization status.
            </p>
          )}
        </section>
      </div>
    </>
  );
}
